<ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
  <ng-container *ngSwitchCase="'wettarena'">
    <div class="slider-desktop">
      <ng-image-slider
        [manageImageRatio]="true"
        [infinite]="true"
        [showArrow]="false"
        [autoSlide]="5"
        [images]="imageObject"
        [imageSize]="{ width: '100%', height: 180, space: 0 }"
        [showArrow]="false"
        [imagePopup]="false"
        (imageClick)="goPage($event)"
        [animationSpeed]="3"
        #nav></ng-image-slider>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'b500'">
    <div class="slider-desktop">
      <ng-image-slider
        [manageImageRatio]="true"
        [infinite]="true"
        [showArrow]="false"
        [autoSlide]="5"
        [images]="imageObject"
        [imageSize]="{ width: '100%', height: 180, space: 0 }"
        [showArrow]="false"
        [imagePopup]="false"
        (imageClick)="goPage($event)"
        [animationSpeed]="3"
        #nav></ng-image-slider>
    </div>
  </ng-container>
</ng-container>
<div class="slider-mobile">
  <ng-container *ngIf="imageObject && imageObject.length > 0">
    <ng-image-slider
      [manageImageRatio]="true"
      [infinite]="true"
      [showArrow]="false"
      [autoSlide]="4"
      [images]="imageObject"
      [imageSize]="{ width: '100%', height: 120, space: 0 }"
      [showArrow]="false"
      [imagePopup]="false"
      (imageClick)="goPage($event)"
      animationSpeed="3"
      #nav></ng-image-slider>
  </ng-container>
</div>
